import fila from './filaRepository'
import parametrizacao from './parametrizacaoRepository'
import solicitacao from './solicitacaoRepository'
import status from './statusRepository'

export default baseUrl => {

    baseUrl = `${baseUrl}/regulacao`

    return {
        fila: fila(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        solicitacao: solicitacao(baseUrl),
        status: status(baseUrl),
    }
}